export default (s) => `${s} | Flipboard`;
